import { NetworkSignal, networkSignal } from "@/utils/signals";
import { KeyVal } from "@/api";
import { initApi } from "@/utils";

export type UseVariableUpdate = {
  mutate: (name: string, value: string) => Promise<KeyVal | undefined>;
} & Omit<NetworkSignal<KeyVal>, "run">;

export function useVariableUpdate(): UseVariableUpdate {
  const variableUpdateSignal = networkSignal<KeyVal | undefined>({
    retry: { maxAttempts: 3, delayMs: 2000, backoffMultiplier: 2 },
  });

  async function updateVariable(name: string, value: string): Promise<KeyVal | undefined> {
    const api = initApi();
    return await api.setUserVariable({ keyVal: { key: name, value } });
  }

  /**
   * Mutate function to trigger variable update
   */
  const mutate = async (name: string, value: string) =>
    variableUpdateSignal.run(async () => updateVariable(name, value));

  return { mutate, ...variableUpdateSignal };
}
